"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultCancellationReasons = void 0;
const defaultCancellationReasons = exports.defaultCancellationReasons = [{
  value: 'Poor customer support',
  key: 'unsubscribe-popup.cancellation.poor-customer-support'
}, {
  value: 'Switch to a different service',
  key: 'unsubscribe-popup.cancellation.service-switch'
}, {
  value: 'Subscription is too expensive',
  key: 'unsubscribe-popup.cancellation.too-expensive'
}, {
  value: 'Video streaming issues',
  key: 'unsubscribe-popup.cancellation.streaming-issues'
}, {
  value: 'Not enough interesting content',
  key: 'unsubscribe-popup.cancellation.not-interesting-content'
}, {
  value: 'Service is hard to use',
  key: 'unsubscribe-popup.cancellation.hard-to-use'
}, {
  value: 'Content I like has ended',
  key: 'unsubscribe-popup.cancellation.content-ended'
}];

// eslint-disable-next-line import/prefer-default-export